import emptyFieldValidate from "./empty.validate";

const urlFieldValidate = (
  field: string,
  name: string,
  validateEmptyField: boolean = false
) => {
  try {
    if (field) {
      Boolean(new URL(field));
    }

    return validateEmptyField ? emptyFieldValidate(field, name) : undefined;
  } catch (e) {
    return `${name} field should be a valid URL.`;
  }
};

export default urlFieldValidate;
